var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CenterPointIcon',{staticClass:"accent--text",class:{'heading': typeof _vm.centerPoint.hdg === 'number'},style:({transform: ("rotate(" + (_vm.centerPoint.hdg||0) + "deg)")})})}
var staticRenderFns = []

export { render, staticRenderFns }